const HeroSection = ({ t, lang, data }) => {
    return (
    <section className="py-5 bg-card position-relative overflow-hidden">
        <div className="container py-4 Why_Choose">
            <div className="text-center mb-0 pb-4" data-aos="zoom-in">
                <h2 className="fw-bold display-5 mb-3">
                    {lang === "en" ? "Why Choose Us" : "ليه تختارنا؟"}
                </h2>
                <p className="text-muted fs-5">
                    {t("home_whay_des")}
                </p>
            </div>

            {[
                {
                    icon: "ri-lightbulb-flash-line",
                    title: t("whay_title_1"),
                    desc: t("why_desc_1"),
                    align: "start",
                },
                {
                    icon: "ri-team-line",
                    title: t("why_title_2"),
                    desc: t("why_desc_2"),
                    align: "end",
                },
                {
                    icon: "ri-customer-service-2-line",
                    title: t("why_title_3"),
                    desc: t("why_desc_3"),
                    align: "start",
                },
                {
                    icon: "ri-shield-check-line",
                    title: t("why_title_4"),
                    desc: t("why_desc_4"),
                    align: "end",
                },
                {
                    icon: "ri-line-chart-line",
                    title: t("why_title_5"),
                    desc: t("why_desc_5"),
                    align: "start",
                },
                {
                    icon: "ri-hand-heart-line",
                    title: t("why_title_6"),
                    desc: t("why_desc_6"),
                    align: "end",
                },
            ].map((item, i) => (
                <div
                    className={`row align-items-center mb-3 justify-content-${item.align} py-2
                    `}
                    key={i}
                    data-aos={i % 2 === 0 ? "fade-up bg-card" : "zoom-in bg-body"}
                >
                    <div
                        className={`cont-why d-flex flex-column flex-lg-row py-3 col-lg-9 shadowP ${
                            i % 2 === 0 ? "bg-body" : "bg-card"
                        }`}
                    >
                        <div
                            className={`col-lg-6 ${
                                item.align === "start" ? "order-lg-2" : ""
                            } mb-3 text-center`}
                        >
                            <div className="d-flex align-items-center justify-content-center top-icon-why">
                                <div className="position-relative">
                                    <div className="bg-primary opacity-25 rounded-circle position-absolute cont-why-icon"></div>
                                    <i className={`${item.icon} text-primary position-relative why-icon`}
                                    ></i>
                                </div>
                            </div>
                        </div>
                        <div
                            className={`col-lg-6 ${
                                item.align === "start" ? "order-lg-1" : ""
                            } text-center text-lg-start`}
                        >
                            <h3 className="fw-bold mb-3">{item.title}</h3>
                            <p className="text-muted fs-md-5 mb-0 small">{item.desc}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </section>
);
};

export default HeroSection;